import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import {
  ImportTariffModel,
  ImportTariffNewModel,
} from '../../../core/models/tariff.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { ModalSupplierComponent } from '../../person/supplier/modal_supplier/modal-supplier.component'
import { ImportTariffService } from '../../../core/services/tariff/import-tariff/import-tariff.service'
import { ModalLegalEntityClientSubNewComponent } from '../../customer/modal_client/modal-legal-entity-client-sub-new/modal-legal-entity-client-sub-new.component'

@Component({
  selector: 'tariff-import',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './tariff-import.component.html',
  styleUrl: './tariff-import.component.scss',
  providers: [TariffService, TariffTypeService],
  standalone: true,
})
export class TariffImportComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private tariffService: TariffService,
    private tariffTypeService: TariffTypeService,
    private importTariffService: ImportTariffService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<TariffImportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data && data.user) {
      this.item = { user: true, data: data.item }
    }
  }

  @Output() responseEdit = new EventEmitter()

  item: any = { user: false, data: [] }
  form: FormGroup = new FormGroup({})
  loading: boolean = false
  subClient: boolean = false

  listType: any[] = []

  file: File | null = null
  allowedTypes = [
    'xlsx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ]
  clientSelected: any = {}
  supplierSelected: any = {}

  ngOnInit(): void {
    this.listTypeTariff()
    this.createForm()
  }

  listTypeTariff() {
    this.tariffTypeService.listTariffType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  importItem() {
    this.loading = true
    const model = this.createModel()
    this.importTariffService.importTariff(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
    // this.tariffService.importTariff(model).subscribe({
    //   next: (response: ResponseRequestModel) => {
    //     this.snackbar.success(response.message)
    //     this.responseEdit.emit(true)
    //     this.close()
    //   },
    //   error: (err: ErrorRequestModel) => {
    //     this.loading = false
    //     this.snackbar.errorRequest(err)
    //   },
    //   complete: () => {
    //     this.loading = false
    //     this.form.reset()
    //   },
    // })
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      this.file = input.files[0]
      this.form.get('file')?.setValue(this.file.name)
    }
  }

  getAllowedTypes() {
    return this.allowedTypes.map((item) => `.${item}`).join(', ')
  }

  checkFile() {
    if (this.file) {
      const arrFile = this.file.name.split('.')
      const extensionFile = arrFile[arrFile.length - 1]
      if (
        this.allowedTypes.includes(this.file.type) &&
        this.allowedTypes.includes(extensionFile.toLowerCase())
      ) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  validClient() {
    if (this.form.get('tariffType')!.value == 2 && !this.clientSelected.id) {
      return false
    } else {
      return true
    }
  }

  checkForm() {
    if (this.checkFile() && this.form.valid && this.validClient()) {
      return true
    } else {
      return false
    }
  }

  close() {
    this.dialogRef.close()
  }

  createModel() {
    const model = new ImportTariffNewModel()
    model.TipoTarifario = this.form.get('tariffType')!.value
    model.ClienteId = this.clientSelected.id ? this.clientSelected.id : 0
    model.FornecedorId = this.supplierSelected.id ? this.supplierSelected.id : 0
    model.ExcelFile = this.file

    return model.toFormData()

    // const model = new ImportTariffModel()
    // model.TipoTarifario = this.form.get('tariffType')!.value
    // model.ClienteId = this.clientSelected.id ? this.clientSelected.id : 0
    // model.ExcelFile = this.file
    //
    // return model.toFormData()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      tariffType: [1, [Validators.required]],
      client: [''],
      supplier: [''],
      file: ['', [Validators.required]],
    })
    if (this.item.user) {
      this.clientSelected = this.item.data
      this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
      this.form.get('supplier')!.setValue(this.supplierSelected.nomeFantasia)
      this.form.get('tariffType')!.setValue(2)
      this.form.get('tariffType')!.disable()
      this.form.get('client')!.disable()
    } else {
      this.form.get('client')!.disable()
    }
  }

  onSelectionChange(event: MatSelectChange) {
    if (event.value == 1) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
      this.form.get('client')!.disable()
    } else {
      this.form.get('client')!.enable()
    }
  }

  // addClient() {
  //   const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
  //     enterAnimationDuration: '100ms',
  //     exitAnimationDuration: '100ms',
  //     maxWidth: '1200px',
  //     minWidth: '1200px',
  //     maxHeight: '650px',
  //     data: {
  //       item: this.clientSelected,
  //       multiSelect: false,
  //     },
  //   })
  //   dialogRef.componentInstance.responseSingle.subscribe((response) => {
  //     if (response) {
  //       if (response.remove == false) {
  //         this.clientSelected = response.selection
  //         this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
  //       } else {
  //         this.clientSelected = {}
  //         this.form.get('client')!.setValue('')
  //       }
  //     }
  //   })
  // }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientSubNewComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        subClient: this.subClient,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.clientSelected = response.selection
          this.subClient = response.subClient
          this.form.get('client')!.setValue(this.clientSelected.nomeFantasia)
        } else {
          this.clientSelected = {}
          this.form.get('client')!.setValue('')
        }
      }
    })
  }

  addSupplier() {
    const dialogRef = this.dialog.open(ModalSupplierComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.supplierSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          this.supplierSelected = response.selection
          this.form
            .get('supplier')!
            .setValue(this.supplierSelected.nomeFantasia)
        } else {
          this.supplierSelected = {}
          this.form.get('supplier')!.setValue('')
        }
      }
    })
  }
}
